// Croatian flag — three stripes + simplified šahovnica.

export default function CroFlag({ size = 30 }) {
  const w = size;
  const h = size * 0.66;
  return (
    <svg width={w} height={h} viewBox="0 0 30 20" style={{ borderRadius: 4, display: 'block' }}>
      <rect width="30" height="6.67" fill="#E63946" />
      <rect y="6.67" width="30" height="6.67" fill="#fff" />
      <rect y="13.33" width="30" height="6.67" fill="#2D5BFF" />
      <g transform="translate(11.5 5.5)">
        <rect width="7" height="7" fill="#fff" stroke="#E63946" strokeWidth="0.6" />
        <rect width="1.75" height="1.75" fill="#E63946" />
        <rect x="3.5" width="1.75" height="1.75" fill="#E63946" />
        <rect x="1.75" y="1.75" width="1.75" height="1.75" fill="#E63946" />
        <rect x="5.25" y="1.75" width="1.75" height="1.75" fill="#E63946" />
        <rect y="3.5" width="1.75" height="1.75" fill="#E63946" />
        <rect x="3.5" y="3.5" width="1.75" height="1.75" fill="#E63946" />
        <rect x="1.75" y="5.25" width="1.75" height="1.75" fill="#E63946" />
        <rect x="5.25" y="5.25" width="1.75" height="1.75" fill="#E63946" />
      </g>
    </svg>
  );
}
